const loadedFontsSet = new Set();

export const loadFont = async (fontName, fontSourceUrl) => {
  if (loadedFontsSet.has(fontName)) {
    return;
  }

  const dynamicFont = new FontFace(fontName, `url(${fontSourceUrl})`);
  await dynamicFont.load();

  loadedFontsSet.add(fontName);
  document.fonts.add(dynamicFont);
};
